import { cn } from "../lib/utils";

function Skeleton({ className, ...props }) {
  return <div className={cn("animate-pulse rounded-md bg-[#e8eaf6]", className)} {...props} />;
}

export { Skeleton };
